import React from "react";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { uiActions } from "../../../../../store/ui/ui-slice";

import { Button, CustomSelect, Error, Label } from "../../..";
import {
  generateRandomId,
  lowerFirstLetterUsingRegex,
} from "../../../../helper/common";
import TournamentSchema from "../../../../Schema/Game/TournamentSchema";
import { API_TOURNAMENT } from "../../../../../utils/api/ApiConstant";
import { postAxios } from "../../../../Services/commonService";
import { useFilteredData } from "../../../../Hooks";
import {
  sanitizeNameInput,
  sanitizePositiveNumberInput,
} from "../../../../../utils/inputUtils";

const TournamentModal = ({ handleModalHide, rowData, fetchData }) => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    setError,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      id: "",
      name: "",
      displayOrder: "",
      eventTypeId: null,
    },
    resolver: yupResolver(TournamentSchema),
  });

  const sport = watch("eventTypeId");
  const onSubmit = async (values) => {
    const payload = {
      id: values?.id,
      eventTypeId: values?.eventTypeId.value,
      name: values?.name,
      displayOrder: Number(values?.displayOrder),
    };

    const res = await postAxios(API_TOURNAMENT, payload);

    if (res?.success) {
      fetchData();
      handleModalHide();
    }
    res?.errors?.forEach((element) => {
      const field = lowerFirstLetterUsingRegex(element?.field);
      if (field)
        setError(field, {
          type: "manual",
          message: element.message,
        });
    });
  };

  const { sportOptions } = useFilteredData({
    sport: sport?.value,
    enableTournament: false,
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <fieldset disabled={isSubmitting}>
        <div className="row ">
          <div className="col-lg-6 col-12">
            <div className="form-group">
              <Label htmlFor="id" className="form-label" isRequired={true}>
                Id
              </Label>
              <input
                type="text"
                className={`form-control ${errors.id ? "is-invalid" : ""}`}
                id="id"
                placeholder="Enter Id"
                autoFocus={true}
                tabIndex={1}
                {...register("id", {
                  onChange: (e) => {
                    e.target.value = sanitizePositiveNumberInput(
                      e.target.value,
                    );
                  },
                })}
              />
              {errors.id && <Error>{errors.id.message}</Error>}
            </div>
          </div>
          {/* Sport Select */}
          <div className="col-lg-6 col-12 ">
            <div className="form-group">
              <Label
                htmlFor="eventTypeId"
                className="form-label"
                isRequired={true}
              >
                Sport
              </Label>
              <Controller
                name="eventTypeId"
                control={control}
                render={({ field }) => (
                  <CustomSelect
                    options={sportOptions}
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    placeholder="Select Sport"
                    isMulti={false}
                    tabIndex={2}
                  />
                )}
              />
              {errors.eventTypeId && (
                <Error>{errors.eventTypeId.message}</Error>
              )}
            </div>
          </div>

          {/* Tournament Name */}
          <div className="col-lg-6 col-12">
            <div className="form-group">
              <Label htmlFor="name" className="form-label" isRequired={true}>
                Tournament
              </Label>
              <input
                type="text"
                className="form-control"
                id="name"
                placeholder="Enter name"
                {...register("name", {
                  onChange: (e) => {
                    e.target.value = sanitizeNameInput(e.target.value);
                  },
                })}
                tabIndex={3}
              />
              {errors.name && <Error>{errors.name.message}</Error>}
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="form-group">
              <Label
                htmlFor="displayOrder"
                className="form-label"
                isRequired={true}
              >
                Display Order
              </Label>
              <input
                type="text"
                className={`form-control ${errors.displayOrder ? "is-invalid" : ""}`}
                id="displayOrder"
                placeholder="Enter Display Order"
                {...register("displayOrder", {
                  onChange: (e) => {
                    e.target.value = sanitizePositiveNumberInput(
                      e.target.value,
                    );
                  },
                })}
                tabIndex={4}
              />
              {errors.displayOrder && (
                <Error>{errors.displayOrder.message}</Error>
              )}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end w-100 mt-2">
          <Button
            type="button"
            className="btn btn_main btn_muted px-3 py-2 mx-1"
            onClick={handleModalHide}
            tabIndex={6}
          >
            Close
          </Button>
          <Button
            type="submit"
            className="btn btn_main px-3 py-2 mx-1"
            tabIndex={5}
            isDisabled={isSubmitting}
          >
            {isSubmitting ? "Loading.." : "Submit"}
          </Button>
        </div>
      </fieldset>
    </form>
  );
};

export default TournamentModal;
